import { ThemeOptions } from "@mui/material/styles";

export const inputLabelOverrides: ThemeOptions["components"] = {
	MuiInputLabel: {
		styleOverrides: {
			root: ({ theme }) => ({
				color: theme.palette.black["500"],

				"&.Mui-disabled": {
					color: theme.palette.dirtyWhite["800"],
				},
			}),

			outlined: ({ theme }) => ({
				transform: `translate(${theme.spacing(3)}, ${theme.spacing(2.5)}) scale(1)`,

				"&.MuiInputLabel-shrink": {
					transform: `translate(${theme.spacing(3)}, ${theme.spacing(-2)}) scale(0.75)`,
				},
			}),
		},
	},
};
